import { render, staticRenderFns } from "./basic-configuration.vue?vue&type=template&id=d42179fa&scoped=true"
import script from "./basic-configuration.vue?vue&type=script&lang=ts"
export * from "./basic-configuration.vue?vue&type=script&lang=ts"
import style0 from "./basic-configuration.vue?vue&type=style&index=0&id=d42179fa&prod&lang=scss&scoped=true"
import style1 from "./basic-configuration.vue?vue&type=style&index=1&id=d42179fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42179fa",
  null
  
)

export default component.exports